//=============================================================================
//                       <--- Developed By Icon Team ---> 18 January 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import context from "context/context";
import { useHistory } from "react-router-dom";
import * as moment from "moment";


// custom pages
import Table from "components/Table/Table";
import emailTemplete from "apis/EmailTemplete/emailTemplete";
import { styles } from "./styles";
import Loader from "components/Loader/Loader";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { useTranslation } from 'react-i18next';
import { CSVLink } from 'react-csv';
import { toast } from "react-toastify";
import { exportHeaders } from "./export";
import HistoryTable from "components/Table/History/HistoryTable";

// material-ui
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";

// material-ui icons
import Grid from "@material-ui/core/Grid";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";

export default function EmailTemplete(props) {
  const { state, dispatch } = useContext(context);
  const { getEmailTemplete,exports } = emailTemplete();

  const history = useHistory();
  const classes = styles();

  const [data, setData] = useState([]);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [res, setRes] = useState(false);
  const { t, i18n } = useTranslation();
  const [exportData, setExportData] = useState([]);
  
  const [isActive, setIsActive] = useState(true);

  // For bread-crumbs
  useEffect(() => {
    dispatch({ type: "SET_PATHNAME", payload: ["HOME", "ADMIN", "Email Template"] });
  }, []);

  const [states, setstates] = useState({ historyLoader: false });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  const { historyLoader } = states;

  // change pagination func
  const handlePagination = (value) => {
    setOffset(value);
  };

  // handling api calls
  useEffect(() => {
    handleGet();
  }, [offset, isActive]);

  // get api func
  const handleGet = async () => {
    try {
      dispatch({ type: 'SET_LOADING', payload: true })
      let values;
      values = {
        offset: (offset - 1) * 10,
        limit: 10
      };
      let res = await getEmailTemplete(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        setRes(true);
      }
      dispatch({ type: 'SET_LOADING', payload: false })
    }
    catch (e) {
      console.log({ e });
    }
  };

  const handleExport = async () => {
    let values = {};
    // let values = {};
   
    // setLoading(true)
    

    dispatch({ type: "SET_LOADING", payload: true });
    let res = await exports(values);
    console.log(res,"ragav")
    if (res && res.data) {
        // setIsLoading(false);
        setExportData(res.data.map((d) => {
          return {
            ...d,
          
              is_active: d.is_active.toString()
         

          };
          
        })); 
        dispatch({ type: "SET_LOADING", payload: false });
       
        if (res.data.length === 0) {
          toast.success(t("No Data Found"), { toastId: "no-report-date" });
          return false;
        }
       
        return true;
      }
    }

  return (
    <React.Fragment>
      <Grid container className={classes.root}>
        {/* <Grid item xs={12} sm={12} lg={12} style={{ position: 'relative' }}>
          <Button
            className={`${classes.createBtn} dash-1-filter-btn`}
            onClick={() => {
              history.push("/dashboard/create-emailtemplete");
            }}
          >
            {'Create'}
          </Button>
        </Grid> */}
        <CSVLink
            id="csv"
            data={exportData}
              
             headers={exportHeaders}
         filename={
              `Email-Template` +
              " " +
              moment(new Date()).format("MM-DD-YYYY,h:mm A") +
              ".csv"
            }
            className={classes.CSVlink}
          />
                <button
            // disabled={isLoading}
            className={classes.exportBtn1}
            onClick={async () => {
              let res = await handleExport();
              if (res) {
                document.getElementById("csv").click();
              }
            }}
          >
            {t('Export')}
          </button>
      </Grid>
      <Loader loading={state.loading} top="15%">
        <Grid className={classes.tableDownInResponsive}>
          <Grid item xs={12} sm={12} lg={12}>
            {res ? (
              <Table
                headings={[
                  "S.No",
                  "Template",
               "Status",
               "Enable Email",
               "Domain Name",
               "Reply Email",
               "View"
                ]}
                data={
                  data &&
                  data.length > 0 &&
                  data.map((d, i) => [
                    ((offset - 1) * 10) + (i + 1),
                    d?.template,
                    d?.is_active ? (
                      <span style={{ color: "green" }}>{"True"}</span>
                    ) : (
                      <span style={{ color: "red" }}>{"False"}</span>
                    ),
                    d?.enable_email ? (
                      <span style={{ color: "green" }}>{"True"}</span>
                    ) : (
                      <span style={{ color: "red" }}>{"False"}</span>
                    ),
                    d?.domain_name ? d?.domain_name : '-',
                    d?.reply_to ? d?.reply_to : '-',
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        history.push("/dashboard/view-emailtemplate", { data: d });
                      }}
                    >
                      <VisibilityIcon />
                    </div>
                  ])
                }
                offset={offset}
                count={
                  (count / 10) % 1 == 0
                    ? Math.floor(count / 10)
                    : Math.floor(count / 10 + 1)
                }
                handlePagination={handlePagination}
              />
            ) : (
              <Loader Loading={true} top={"15%"} />
            )}
          </Grid>
        </Grid>
      </Loader>
 
    </React.Fragment>
  );
}
